module.exports = __webpack_public_path__ + "static/media/inetcfg_2300.b51938a5.ico";